const Operator = Object.freeze({
    EQ: 'EQ',
    NE: 'NE',
    LT: 'LT',
    GT: 'GT',
    LE: 'LE',
    GE: 'GE',
    BETWEEN: 'BETWEEN',
});

export { Operator };
